import { Mutations } from 'vuex-smart-module';

import { Poll } from '../types';

import PollsState from './state';

export default class PollsMutations extends Mutations<PollsState> {
  setPolls(polls: Poll[]) {
    this.state.polls = polls;
  }
}
